<template>
  <section class="hero is-info is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="has-text-centered">
          <img src="/static/img/logo/logo.svg" alt="HP Logo" width="121" height="30">
        </div>
        <h1 class="title has-text-centered font-roboto">
          Please wait while we publish your review...
        </h1>
        <flash-message :addBottomMargin="true" :class="{'isErrorVisible': isErrorVisible}"></flash-message>
        <h2 class="subtitle">
          <p class="has-text-centered spinner"><img src="/static/img/others/spinner.svg" alt="Activating your account..."/></p>
        </h2>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import axios from 'axios'
import ApiResource from '@/api/ApiResource'
import Rating from '@/components/FormRating'
import misc from '@/mixins/misc.js'
import auth from '@/mixins/auth.js'
import FlashMessage from '@/components/FlashMessage'
import ReviewBusinessSearch from '@/components/ReviewBusinessSearch'

export default {
  name: 'WriteEmailReview',
  mixins: [misc, auth],
  props: {
    slug: {
      type: String,
      default: ''
    }
  },
  components: {
    Rating,
    FlashMessage,
    ReviewBusinessSearch
  },
  metaInfo() {
    return {
      title: this.metaTitle
    }
  },
  data() {
    return {
      isErrorVisible: false,
      is_fetching_initial_data: false,
      is_loading: false,
      ratingSpacer: true,
      fullWidthDropDown: true,
      show_dropdown: false,
      industries: [],
      selectedIndustry: 'Select industry',
      businessPropertyDetail: {
        id: 0,
        industry_id: 0,
        industry_name: '',
        name: ''
      },
      form: new ApiResource({
        business: '',
        business_id: '',
        business_name: '',
        industry: '',
        rating: 0,
        content: '',
        review_title: '',
        new_business_email: '',
        reference_number: '',
        id_number: '',
        cell_number: ((localStorage.getItem('mobile') !== 'null' && localStorage.getItem('mobile')) ? localStorage.getItem('mobile') : ''),
        branch: '',
        status: '',
        subscription: '',
        source: '',
        full_url: '',
        token: (this.$router.currentRoute.query.t === undefined) ? null : this.$router.currentRoute.query.t,
        uploadedPhotos: [],
        sendWebhook: ''
      }),
      businesses: [],
      org_selected: false,
      business_available: undefined,
      drop_down_opened: false,
      on_blur_close: false,
      showUnclaimedBizEmail: false,
      is_new_user: false,
      canUploadPhotos: (['UE9SVEFMX0lOVklURQ==', 'U01TX0lOVklURQ=='].includes(this.$route.query.source)) ? true : false //Email invite or SMS invite
    }
  },
  created() {
    //check if review already written for a single invite link
    if (this.$router.currentRoute.query.t !== undefined && !this.isLoggedIn) {
      this.isReviewerAlreadyWrittenReviewForInvite()
    } else if (!this.isLoggedIn) {
      let query = JSON.parse(JSON.stringify(this.$route.query))
      this.$router.push({path: '/login', query})
    }
    this.getIndustries()
    if (this.$route.query.rate && (typeof this.$route.query.rate !== 'undefined')) {
      this.form.rating = this.$route.query.rate
    }
    if (this.$route.query.reviewTitle && (typeof this.$route.query.reviewTitle !== 'undefined')) {
      this.form.review_title = this.$route.query.reviewTitle
    }
    if (this.$route.query.reviewContent && (typeof this.$route.query.reviewContent !== 'undefined')) {
      this.form.content = this.$route.query.reviewContent
    }
    if (this.$route.query.source && (typeof this.$route.query.source !== 'undefined')) {
      this.form.source = this.$route.query.source
      this.form.full_url = this.$route.fullPath
    }
    if (typeof this.$route.query.completionRedirect !== 'undefined' && this.$route.query.completionRedirect.length > 0) {
      this.form.sendWebhook = this.$route.query.completionRedirect
    }
    if (this.slug.length > 0) {
      /**
       * if all the review data is present in query string, we directly post review to API
       */
      if (
        (this.$route.query.rate && typeof this.$route.query.rate !== 'undefined') &&
        (this.$route.query.reviewTitle && typeof this.$route.query.reviewTitle !== 'undefined') &&
        (this.$route.query.reviewContent && typeof this.$route.query.reviewContent !== 'undefined') &&
        (this.$route.query.source && typeof this.$route.query.source !== 'undefined') &&
        (this.$route.query.t && typeof this.$route.query.t !== 'undefined')
      ) {
        this.getBasicBusinessDetail().then(() => {
          this.publishReview();
        })
      } else {
        this.getBasicBusinessDetail().then(() => {
          this.registerConsumerByToken();
        })
      }

    } else {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: this.metaTitle,
        brandName: '',
        industryName: ''
      })
      window.prerenderReady = true
    }

    window.events.$on('business-search', this.selectOrg)
  },
  destroyed() {
    window.events.$off('business-search')
  },
  methods: {
    /**
     * check whether biz reviewed within 72 hours
     *
     * @returns {void}
     */
    isBizAlreadyReviewed() {
      axios.get(`/consumer/business/${this.form.business_slug}/biz-review-detail`)
        .then(({data}) => {
          if (data && data.lastReviewTimeDiff <= 72) {
            this.form.industry = ''
            this.slug = ''
            this.form.business_id = 0
            this.form.business_name = ''
            this.latestReview = data
            this.isErrorVisible = false
            flash(this.getDuplicateReviewErrorMessage, 'is-warning', true)
          } else {
            this.isErrorVisible = true
          }
        })
        .catch(() => {
          this.isErrorVisible = true
        })
        .finally(() => {
          this.form.reference_number = ''
          this.form.id_number = ''
          this.form.branch = ''
        })
    },
    getBasicBusinessDetail() {
      return new Promise((resolve) => {
        axios.get(`/consumer/business/${this.slug}/basic-detail`)
          .then(({data}) => {
            this.businessPropertyDetail = data
            this.form.subscription = data.subscription
            this.form.business_id = data.id
            this.form.business_slug = this.slug
            this.form.business_name = data.name
            if (data.status !== 'ACTIVE' && data.subscription === '' && !data.accepted_invites_count) {
              this.showUnclaimedBizEmail = true;
            } else {
              this.showUnclaimedBizEmail = false;
            }
            window.prerenderReady = true
            this.$gtm.trackEvent({
              event: 'pageLoad',
              virtualPageUrl: this.$router.currentRoute.path,
              virtualPageTitle: this.metaTitle,
              brandName: data.name,
              industryName: ''
            })
            resolve()
          })
          .catch(() => {
            this.$router.push('/write-an-email-review')
          })
      });
    },
    publishReview() {
      this.form.errors.clear(null)
      this.is_loading = true
      this.form.send('/consumer/reviews/write')
        .then((response) => {
          localStorage.setItem('new_review', JSON.stringify(response))
          this.is_loading = false

          this.recache()
          this.recacheReviewDetail(response.business_slug, response.permalink) //Review detail page
          this.recache(`/${response.business_slug}`) //Business detail page
          this.recache(`/industries/${response.industry_slug}`) //Industry details page

          this.$router.push('/thank-you')
        })
        .catch((err) => {
          this.is_loading = false
          if (err.error && err.already_written_review_for_invite) {
            this.$router.push(`/${err.business_slug}?already_written_review_for_invite=true`)
          } else if (err.error) {
            flash(this.getDuplicateReviewErrorMessage, 'is-danger', true)
          }
        })
    },
    getIndustries() {
      axios.get('/search/industries/')
        .then(({data}) => {
          this.industries = data
        })
        .catch(() => {
          flash('Error retrieving the list of industries! Contact the System\'s Administrator.', 'is-danger', true)
        })
    },
    selectOrg(business) {
      if (typeof business !== 'undefined') {
        this.org_selected = true
        this.form.business_name = business.name.trim()
        this.form.business_slug = business.slug
        this.form.business_id = business.id
        this.form.status = business.status
        this.form.new_business_email = ''
        this.businesses = []

        if (typeof business.subscription !== 'undefined' && business.subscription !== null && typeof business.subscription.name !== 'undefined') {
          this.form.subscription = business.subscription.name
        }
        if (typeof business.id !== 'undefined' && business.id !== null) {
          this.isBizAlreadyReviewed()
        }

        if (business.status !== 'ACTIVE' && business.subscription === null && !business.accepted_invites_count) {
          this.showUnclaimedBizEmail = true
          this.form.subscription = ''
        } else {
          this.showUnclaimedBizEmail = false
        }
        this.drop_down_opened = false
      }
    },
    isReviewerAlreadyWrittenReviewForInvite() {
      let token = this.form.token
      axios.get(`/consumer/reviews/is-already-written-review-for-single-invite/${token}`)
        .then(({data}) => {
          this.is_new_user = data.is_new_user
          if (!data.is_valid) {
            this.$router.push(`/${data.business_slug}?already_written_review_for_invite=true`)
          }
        })
        .catch(() => {
          this.$router.push('/login')
        })
    },
    registerConsumerByToken() {
      const token = this.form.token
      this.form.errors.clear(null)
      this.is_loading = true
      this.form.send('/consumer/registerconsumerbytoken')
        .then((response) => {
          this.isErrorVisible = false
          localStorage.setItem('auth_token', response.token)
          localStorage.setItem('profile_id', response.profile_id)
          localStorage.setItem('mobile', response.mobile)
          localStorage.setItem('displayName', response.displayName)
          localStorage.setItem('avatar', response.avatar)
          this.$gtm.trackEvent({
            event: 'conversionSuccess',
            type: 'Login'
          })
          this.$router.push(`/write-a-review/${this.slug}?t=${token}`)
        }).catch((err) => {
        this.is_loading = false
        if (err.error && err.already_written_review_for_invite) {
          this.$router.push(`/${err.business_slug}?already_written_review_for_invite=true`)
        } else if (err.error && err.blank) {
          this.$router.push(`/write-a-review/${this.slug}?blank=true`)
        } else if (err.error) {
          this.isErrorVisible = true
          flash(err.error, 'is-danger', true)
        }
      })
    }
  },
  computed: {
    /**
     * return error message in html string
     *
     * @returns {html}
     */
    getDuplicateReviewErrorMessage() {
      return `<ul>
            <li style="font-weight: 500;">It looks like you have recently reviewed this business. If you’re still unhappy, or need your issue resolved, you can do the following:</li>
            <li></li><li></li>
            <li style="font-weight: 500;margin-top:10px;list-style: disc;margin-left: 20px;">  Write a new message on your previous review explaining what you need from the business. <a class="link--v2 link--no-line" href="${this.form.business_slug}/reviews/${this.latestReview.permalink}" target="__blank">Write a new message.</a></li>
            <li ></li><li></li>
            <li style="font-weight: 500;list-style: disc;margin-left: 20px;">  Have a look at similar businesses in this industry who may be able to help you.<a class="link--v2 link--no-line" href="/industries/${this.latestReview.industrySlug}" target="__blank"> View similar businesses.</a></li>
            <li></li><li></li>
            <li style="font-weight: 500;list-style: disc;margin-left: 20px;">  If none of these look good you can always <a class="link--v2 link--no-line" href="/contact-us" target="__blank">contact us</a>, and let us know how we can help.</li>
        </ul>`
    },
    metaTitle() {
      return 'Review Companies Online | Customer Service & Company Ratings | hellopeter.com'
    }
  }
}
</script>
<style scoped>
#write-an-email-review {
  margin-top: auto;
  margin-bottom: auto;
}

.write-review {
  color: #58595B;
  margin: 0 auto;
  width: 601px;
  padding: 2rem;
  background-color: #ffffff;
}

h1 {
  font-size: 1.3rem;
  margin-bottom: 1.8rem;
}

.hero.is-info {
  background-color: #ffffff;
  color: #4a4a4a;
}

.hero .title {
  color: #4a4a4a;;
}

</style>



// WEBPACK FOOTER //
// src/pages/reviews/WriteAnEmailReview.vue